<div class="card h-100 min-vh-79 profile-payment-method__container">
  <div class="card-body flex-none row">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="fw-bold mb-0">Your Payment Methods</h3>
      <button class="template-btn-color ppm__btn btn btn-outline-primary custom-btn-color
        btn-md rounded-pill d-flex align-items-center gap-1">
        <i class="bi bi-plus-lg"></i>
        Add New Payment Method
      </button>
    </div>

    <div class="list-group w-100">
      <div
        class="ppm__list-group-item-action list-group-item list-group-item-action d-flex justify-content-between transition-03
          align-items-center rounded mb-3 col-md-12 border-0 p-4"
        *ngFor="let method of paymentMethods; let i = index"
        [ngClass]="{ 'bg-light': method.active }"
        (click)="updateCreditCardStatus(method)"
      >

        <div class="form-check me-1">
          <input class="form-check-input" type="radio" name="paymentMethod" [checked]="method.active" />
        </div>

        <div class="d-flex align-items-center col-md-2">
          <img [src]="getIconByCreditCardType(method)" alt="Card Logo" height="18" />
        </div>

        <div class="d-flex align-items-center col-md-3">
          <div class="fw-bold">{{ transformTypeAsLabel(method) | titlecase }}</div>
        </div>

        <div class="d-flex align-items-center col-md-4">
          <div class="text-muted">{{ method.cardNumber }}</div>
        </div>

        <div class="d-flex align-items-center gap-3 col-md-2 justify-content-end"
             (click)="$event.stopPropagation(); deletePaymentMethod(method)">
          <button class="ppm__btn btn text-danger p-0" [disabled]="method.active">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

